// extracted by mini-css-extract-plugin
var _1 = "JIOcp elide";
export { _1 as "base" }
